const bundleTerms: Readonly<Record<string, string>> = {
  კოლექცია: 'ნაკრები',
  კოლექციის: 'ნაკრების',
  კოლექციას: 'ნაკრებს',
  კოლექციამ: 'ნაკრებმა',
  კოლექციით: 'ნაკრებით',
  კოლექციაში: 'ნაკრებში',
  კოლექციიდან: 'ნაკრებიდან',
  კოლექციები: 'ნაკრებები',
  კოლექციების: 'ნაკრებების',
  კოლექციებს: 'ნაკრებებს',
  კოლექციებით: 'ნაკრებებით',
  კოლექციებში: 'ნაკრებებში',
  კოლექციებზე: 'ნაკრებებზე',
};

// Saved translations can predate the storefront's bundle terminology.
export function normalizeGeorgianBundleTerms(entries: Record<string, string>) {
  return Object.fromEntries(
    Object.entries(entries).map(([key, value]) => [
      key,
      value.replace(/კოლექცი[ა-ჰ]*/g, (word) => bundleTerms[word] ?? word),
    ]),
  );
}
